var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133510",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133510)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9163 10.6667V6.66667H9.58301V4H22.9163V6.66667H17.583V10.6667H14.9163ZM5.58301 28V17.3333H8.24967V18.6667H12.2497V14.6667H10.9163V12H21.583V14.6667H20.2497V18.6667H24.2497V17.3333H26.9163V28H24.2497V26.6667H8.24967V28H5.58301ZM8.24967 24H24.2497V21.3333H17.583V14.6667H14.9163V21.3333H8.24967V24Z",
    fill: "#D3135A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpl);
export default __webpack_public_path__ + "static/media/gpl.e10c22867d355bd02602735a373084d8.svg";
export { ForwardRef as ReactComponent };